if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.isModal = this.classList.contains('share-button--modal');
        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          fallback: this.querySelector('.share-button__fallback'),
          drawer: this.querySelector('.share-button__drawer'),
          closeButton: this.querySelector('.share-button__close'),
          copyButton: this.querySelector('.share-button__copy'),
          copyLabel: this.querySelector('.js-share-copy-label'),
          copyStatus: this.querySelector('.js-share-copy-status'),
          copyCheck: this.querySelector('.share-button__copy-check'),
          copySpinner: null,
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.elements.copySpinner = this.elements.copyButton
          ? this.elements.copyButton.querySelector('.loading__spinner')
          : null;
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;
        this.copyResetTimer = null;
        this.onModalKeyDown = this.onModalKeyDown.bind(this);
        this.onFallbackClick = this.onFallbackClick.bind(this);

        if (this.isModal && this.elements.fallback) {
          document.body.appendChild(this.elements.fallback);
        }

        if (navigator.share && !this.isModal) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          this.elements.shareButton.addEventListener('click', () => {
            navigator.share({ url: this.getShareUrl(), title: document.title });
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          if (this.elements.copyButton) {
            this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
          }
          if (this.elements.closeButton) {
            this.elements.closeButton.addEventListener('click', this.close.bind(this));
          }
          if (this.isModal && this.elements.fallback) {
            this.elements.fallback.addEventListener('click', this.onFallbackClick);
          }
        }
      }

      getShareUrl() {
        if (
          this.closest('.configurator-share-actions') &&
          window.ConfiguratorUrlState &&
          typeof window.ConfiguratorUrlState.buildShareUrl === 'function'
        ) {
          try {
            return window.ConfiguratorUrlState.buildShareUrl();
          } catch (e) {
            /* fall through to stored URL */
          }
        }
        return this.urlToShare || document.location.href;
      }

      onFocusOut() {
        if (this.isModal) return;
        super.onFocusOut();
      }

      onFallbackClick(event) {
        if (event.target === this.elements.fallback) this.close();
      }

      onModalKeyDown(event) {
        if (event.key === 'Escape') this.close();
      }

      setModalOpen(isOpen) {
        if (!this.elements.fallback) return;
        this.elements.fallback.classList.toggle('is-open', isOpen);
        if (isOpen) {
          this.elements.fallback.removeAttribute('hidden');
        } else {
          this.elements.fallback.setAttribute('hidden', '');
        }
        document.body.classList.toggle('sp-modal-open', isOpen);
      }

      toggleDetails() {
        if (this.isModal) {
          const isOpen = this.mainDetailsToggle.open;
          const url = this.getShareUrl();
          if (this.elements.urlInput) this.elements.urlInput.value = url;
          this.urlToShare = url;
          this.resetModalFeedback();
          this.setModalOpen(isOpen);
          if (isOpen) {
            document.addEventListener('keydown', this.onModalKeyDown);
            if (this.elements.drawer) this.elements.drawer.focus();
          } else {
            document.removeEventListener('keydown', this.onModalKeyDown);
            if (this.elements.shareSummary) this.elements.shareSummary.focus();
          }
          return;
        }

        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      setModalCopyState(state) {
        if (!this.elements.copyButton) return;
        const isLoading = state === 'loading';
        const isCopied = state === 'copied';
        this.elements.copyButton.classList.toggle('loading', isLoading);
        this.elements.copyButton.classList.toggle('is-copied', isCopied);
        this.elements.copyButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        if (this.elements.copySpinner) {
          this.elements.copySpinner.classList.toggle('hidden', !isLoading);
        }
        if (this.elements.copyLabel) {
          const defaultLabel = this.elements.copyLabel.dataset.defaultLabel || 'Copy link';
          const copiedLabel = this.elements.copyLabel.dataset.copiedLabel || 'Copied';
          this.elements.copyLabel.textContent = isCopied ? copiedLabel : defaultLabel;
        }
        if (this.elements.copyStatus) {
          this.elements.copyStatus.textContent = isCopied ? window.accessibilityStrings.shareSuccess : '';
        }
      }

      resetModalFeedback() {
        clearTimeout(this.copyResetTimer);
        this.setModalCopyState('idle');
      }

      copyToClipboard() {
        const url = this.getShareUrl();
        if (this.elements.urlInput) this.elements.urlInput.value = url;
        this.urlToShare = url;
        if (this.isModal) this.setModalCopyState('loading');
        navigator.clipboard.writeText(url).then(() => {
          if (this.isModal) {
            this.setModalCopyState('copied');
            clearTimeout(this.copyResetTimer);
            this.copyResetTimer = setTimeout(() => {
              this.setModalCopyState('idle');
            }, 2500);
            return;
          }
          this.elements.successMessage.classList.remove('hidden');
          this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
          this.elements.closeButton.classList.remove('hidden');
          this.elements.closeButton.focus();
        }).catch(() => {
          if (this.isModal) this.setModalCopyState('idle');
        });
      }

      close() {
        super.close();
        if (this.isModal) {
          this.setModalOpen(false);
          document.removeEventListener('keydown', this.onModalKeyDown);
        }
      }

      updateUrl(url) {
        this.urlToShare = url;
        if (this.elements.urlInput) this.elements.urlInput.value = url;
      }
    }
  );
}
